import { configureStore, isRejectedWithValue } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { combineReducers, type AnyAction, type Dispatch } from 'redux';
import logger from 'redux-logger';

import type { Middleware } from '@reduxjs/toolkit';

import packageDataReducer from './redux/packageDataSlice';
import sessionSliceReducer, { setError } from './redux/sessionSlice';
import { tessituraApiSlice } from './redux/tessituraApiSlice';

const rootReducer = combineReducers({
  packageDataSlice: packageDataReducer,
  sessionSlice: sessionSliceReducer,
  [tessituraApiSlice.reducerPath]: tessituraApiSlice.reducer,
});

const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const statusCode = action.payload?.status || action.meta.response?.status || action.payload?.originalStatus;
    const message = action.payload.data?.message || '';

    if (statusCode) {
      next(setError({
        code: statusCode.toString(),
        message,
      }));
    }
  }

  return next(action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
    .concat(tessituraApiSlice.middleware)
    .concat(rtkQueryErrorLogger)
    .concat(logger as Middleware<{}, any, Dispatch<AnyAction>>), // eslint-disable-line
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept('.', () => store.replaceReducer(rootReducer));
}

setupListeners(store.dispatch);
